import React from 'react';

const IntroText = ({ className, text }) => (
    <p className={className}>
        {text}
    </p>
);

export default IntroText;



// WEBPACK FOOTER //
// ./src/components/modals/sidePanel/IntroText.js